import React from 'react';
import { translations } from '../data/translations';
import { useLanguage } from '../context/LanguageContext';

function UsageGallery({ onImageClick }) {
  const { t, language } = useLanguage();

  const galleryImages = [
    {
      src: '/images/products/usage-gallery/01_1_Corona-Camera_003.jpg',
      alt: { it: 'Radiatore GPO in interni', ru: 'Обогреватель GPO в интерьере' },
      title: { it: 'Radiatore in soggiorno moderno', ru: 'Обогреватель в современной гостиной' }
    },
    {
      src: '/images/products/usage-gallery/01_1_Corona-Camera_005.jpg',
      alt: { it: 'Pannello radiante GPO', ru: 'Панельный обогреватель GPO' },
      title: { it: 'Design elegante in interni', ru: 'Стильный дизайн в интерьере' }
    },
    {
      src: '/images/products/usage-gallery/01_1_CoronaFifth-Camera_003.jpg',
      alt: { it: 'Radiatore GPO a parete', ru: 'Обогреватель GPO на стене' },
      title: { it: 'Installazione a parete', ru: 'Настенная установка обогревателя' }
    },
    {
      src: '/images/products/usage-gallery/01_1_CoronaForth-Camera_002.jpg',
      alt: { it: 'Radiatore a infrarossi GPO', ru: 'Инфракрасный обогреватель GPO' },
      title: { it: 'Riscaldamento ambiente', ru: 'Обогрев помещения' }
    },
    {
      src: '/images/products/usage-gallery/01_1_CoronaForth-Camera_005.jpg',
      alt: { it: 'Radiatore in stanza', ru: 'Обогреватель в комнате' },
      title: { it: 'Riscaldamento confortevole', ru: 'Комфортное отопление' }
    },
    {
      src: '/images/products/usage-gallery/01_1_CoronaSecond-Camera_002.jpg',
      alt: { it: 'Radiatore in vetro GPO', ru: 'Стеклянный обогреватель GPO' },
      title: { it: 'Pannello in vetro premium', ru: 'Премиум стеклянная панель' }
    },
    {
      src: '/images/products/usage-gallery/01_1_CoronaThird-Camera_004.jpg',
      alt: { it: 'Radiatore GPO in uso', ru: 'GPO обогреватель в использовании' },
      title: { it: 'Riscaldamento efficiente', ru: 'Эффективное отопление' }
    },
    {
      src: '/images/products/usage-gallery/01_2_CoronaFifth-Camera_001.jpg',
      alt: { it: 'Radiatore GPO - vista laterale', ru: 'Обогреватель GPO - вид сбоку' },
      title: { it: 'Design ultrasottile', ru: 'Ультратонкий дизайн' }
    },
    {
      src: '/images/products/usage-gallery/01_2_CoronaSecond-Camera_001.jpg',
      alt: { it: 'Pannello radiante in interni', ru: 'Панельный обогреватель в интерьере' },
      title: { it: 'Armonia con l\'interno', ru: 'Гармония с интерьером' }
    },
    {
      src: '/images/products/usage-gallery/01_2_CoronaThird-Camera_001.jpg',
      alt: { it: 'Riscaldamento GPO', ru: 'GPO отопление' },
      title: { it: 'Soluzione moderna per il riscaldamento', ru: 'Современное решение для отопления' }
    },
    {
      src: '/images/products/usage-gallery/1_Italian.jpeg',
      alt: { it: 'Radiatore GPO - infografica', ru: 'Обогреватель GPO - инфографика' },
      title: { it: 'Specifiche tecniche', ru: 'Технические характеристики' }
    },
    {
      src: '/images/products/usage-gallery/2_Italian.jpeg',
      alt: { it: 'Scaldasalviette GPO', ru: 'Полотенцесушитель GPO' },
      title: { it: 'Scaldasalviette per bagno', ru: 'Полотенцесушитель для ванной' }
    },
    {
      src: '/images/products/usage-gallery/3_Italian.jpeg',
      alt: { it: 'Vantaggi GPO', ru: 'Преимущества GPO' },
      title: { it: 'Vantaggi dei prodotti GPO', ru: 'Преимущества продукции GPO' }
    },
    {
      src: '/images/products/usage-gallery/4_Italian.jpeg',
      alt: { it: 'Controllo intelligente GPO', ru: 'Умное управление GPO' },
      title: { it: 'Controllo WiFi dei radiatori', ru: 'WiFi управление обогревателями' }
    },
    {
      src: '/images/products/usage-gallery/5_Italian.jpeg',
      alt: { it: 'Installazione radiatori GPO', ru: 'Установка обогревателей GPO' },
      title: { it: 'Installazione semplice', ru: 'Простая установка' }
    }
  ];

  const handleImageClick = (image, index) => {
    const tempProduct = {
      name: image.title,
      model: language === 'it' ? 'Galleria d\'uso' : 'Галерея использования',
      images: galleryImages.map(img => img.src),
      description: image.alt,
      power: '',
      area: '',
      size: '',
      materials: { it: '', ru: '' },
      installation: { it: '', ru: '' },
      price: ''
    };

    onImageClick(tempProduct, index);
  };

  return (
    <section id="gallery" className="usage-gallery">
      <div className="container">
        <h2 className="section-title">{t(translations.gallery.title)}</h2>
        <p className="section-subtitle">
          {t(translations.gallery.subtitle)}
        </p>

        <div className="gallery-grid">
          {galleryImages.map((image, index) => (
            <div
              key={index}
              className="gallery-item"
              onClick={() => handleImageClick(image, index)}
            >
              <div className="gallery-item-inner">
                <img
                  src={image.src}
                  alt={t(image.alt)}
                  loading="lazy"
                  className="gallery-item-image"
                />
                <div className="gallery-item-overlay">
                  <div className="gallery-item-content">
                    <span className="gallery-item-icon">{'\u{1F50D}'}</span>
                    <span className="gallery-item-title">{t(image.title)}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="gallery-footer">
          <p className="gallery-note">
            {'\u2728'} {t(translations.gallery.clickToView)}
          </p>
        </div>
      </div>
    </section>
  );
}

export default UsageGallery;
